module.exports = __webpack_public_path__ + "img/emoji-congrats.cc3933aa.svg";